<template>
	<v-navigation-drawer 
		app
		drawer="true"
		width="200"
	>
		<div
			style="height: 48px;"
			class="logo-border text-center pa-2"
			@click="() => $router.push({ name: 'landing', })"  
		>
			<Logo />
		</div>
		<v-divider/>
		<v-list
			dense
			nav
		>
			<v-list-item
				v-for="item in itensMenu"
				:key="item.nome"
				:to="item.path"
			>
				<v-list-item-icon>
					<v-icon>{{ item.icone }}</v-icon>
				</v-list-item-icon>

				<v-list-item-content>
					<v-list-item-title>{{ item.nome }}</v-list-item-title>
				</v-list-item-content>
				<v-list-item-icon v-if="temConteudoNovoItem(item)">
					<v-icon color="orange"> mdi-alert-octagram </v-icon>
				</v-list-item-icon>
			</v-list-item>
		</v-list>
		<template v-slot:append>
			<v-divider />
			<v-list
				dense
				nav
			>
				<v-list-item
					v-if="authModule.isAuth"
					@click="authModule.logout"
				>
					<v-list-item-icon>
						<v-icon> mdi-logout-variant </v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title> Sair </v-list-item-title>
					</v-list-item-content>
				</v-list-item>
			</v-list>
		</template>
	</v-navigation-drawer>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { authModule, application } from '@/store'
import Logo from '@/components/ui/Logo.vue'

const itensMenu = computed(() => authModule.activeMenus)

function temConteudoNovoItem(item: typeof authModule['activeMenus'][0]) {
	if (item.nome == 'Home') return application.temNovidades
	return false
}
</script>
